// extracted by mini-css-extract-plugin
export default {"root":"_35yXC","transform":"_3DjLv","swipeable":"_1_GOJ","preview":"_3dmc1","next":"_3HEpp","prev":"_1r1aH"};